import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { storeStockBalance } from './Reducers/StoreStockBalance.reducer';
import { currentProduct } from './Reducers/CurrentProduct.reducer';
import { newsletter } from './Reducers/Newsletter.reducer';
import { variantInformationContent } from './Reducers/VariantInformationContent.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    storeStockBalance,
    currentProduct,
    newsletter,
    variantInformationContent
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
